import React from "react";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import GlobalCta from "../../components/global/GlobalCta";
import PageHero from "../../components/global/PageHero";
import ServiceOverview from "../../components/global/ServiceOverview";
import ServiceFeatures from "../../components/global/ServiceFeatures";
import ServiceChecks from "../../components/global/ServiceChecks";

const OVERVIEW = [
    "Laravel is a modern, elegant PHP framework designed to make web application development faster, cleaner and more enjoyable. Its expressive syntax, powerful tooling and well-organised architecture help us build scalable applications without unnecessary complexity.",
    "It comes with a wide range of built-in features — including authentication, routing, queues, caching and database tools — making it a reliable choice for building secure, high-performance business applications and APIs",
];

const FEATURES = [
    { title: "Elegant & expressive syntax", text: "Clean, readable code makes Laravel applications easier to build, maintain and scale." },
    { title: "Powerful Eloquent ORM", text: "Work with databases using an intuitive ORM that keeps queries readable, flexible and efficient." },
    { title: "Built-in security", text: "Authentication, authorisation, CSRF protection and secure password handling are built into the framework." },
    { title: "Rapid development", text: "Artisan commands, reusable components and Laravel's extensive ecosystem help us deliver features faster." },
];

const CHECKS = [
    "Custom Laravel web applications",
    "Business & admin systems",
    "RESTful APIs",
    "E-commerce platforms",
    "Legacy PHP application modernisation",
    "Ongoing maintenance & support",
];

export default function Laravel() {
    return (
        <>
            <Header />

            <main>
                <PageHero eyebrow="Web Development" title="Laravel Development" eyebrowAs="span">
                    Modern, scalable PHP applications built with Laravel — clean, secure and designed to grow with your business.
                </PageHero>
                <ServiceOverview paragraphs={OVERVIEW} />
                <ServiceFeatures items={FEATURES} />
                <ServiceChecks title="What's included" items={CHECKS} />
            </main>

            <GlobalCta />

            <Footer />
        </>
    );
}
